import { Stack } from "@similarweb/ui-components/foundations";

import MessageLoaderItem from "./MessageLoaderItem";
import type { MessagesListStrategyProps } from "./types";

const FlatMessagesList = ({
    messages,
    renderMessage,
    uiContext,
    isLoading,
    isStreamingLoaderVisible = false,
}: MessagesListStrategyProps) => {
    const lastMessageIndex = messages.length - 1;

    return (
        <>
            {messages.map((msg, index) => {
                const isLastMessage = index === lastMessageIndex;
                const shouldRenderLoader = isLastMessage && isLoading;
                const shouldRenderStreamingLoader = isLastMessage && isStreamingLoaderVisible;

                return (
                    <Stack
                        key={index}
                        width="100%"
                    >
                        {renderMessage(msg, index, isLastMessage)}

                        <MessageLoaderItem
                            isVisible={shouldRenderLoader}
                            marginY="28px 0"
                        >
                            {uiContext.loader}
                        </MessageLoaderItem>
                        <MessageLoaderItem
                            isVisible={shouldRenderStreamingLoader}
                            marginY="12px 0 0 35px"
                        >
                            {uiContext.streamingLoader}
                        </MessageLoaderItem>
                    </Stack>
                );
            })}
        </>
    );
};

export default FlatMessagesList;
